/**
 * Determines whether black or white text should be used
 * for readability on a given background color.
 * Uses relative luminance calculation (WCAG-based).
 */
export const getContrastingLabelColor = (hexColor: string): string => {
  if (!hexColor || !hexColor.startsWith('#')) {
    return '#000000';
  }

  let hex = hexColor;

  // Normalize shorthand hex (#abc -> #aabbcc)
  if (hex.length === 4) {
    hex = '#' + hex[1] + hex[1] + hex[2] + hex[2] + hex[3] + hex[3];
  }

  if (hex.length !== 7) {
    return '#000000';
  }

  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);

  if (isNaN(r) || isNaN(g) || isNaN(b)) {
    return '#000000';
  }

  // Calculate relative luminance with gamma approximation
  const luminance =
    0.2126 * (r / 255) ** 2.2 +
    0.7152 * (g / 255) ** 2.2 +
    0.0722 * (b / 255) ** 2.2;

  return luminance > 0.179 ? '#000000' : '#FFFFFF';
};
